export const Loading = () => {
    return (
        <div id='loading' className='bg-island h-screen w-full flex items-center justify-center align-middle fixed left-0 top-0 z-[99] '>
            <div className='max-w-[591px] w-[60%]'>
                <div className='w-fulll h-0 pt-[17.9357021997%] relative'>
                    <img
                        className='loading-01'
                        src={`${process.env.PUBLIC_URL}/images/loading/deco.png`}
                        alt='Phantom brave key art'
                    />{' '}
                    <img
                        className='loading-02'
                        src={`${process.env.PUBLIC_URL}/images/loading/n.png`}
                        alt='Phantom brave key art'
                    />{' '}
                    <img
                        className='loading-03'
                        src={`${process.env.PUBLIC_URL}/images/loading/o.png`}
                        alt='Phantom brave key art'
                    />{' '}
                    <img
                        className='loading-04'
                        src={`${process.env.PUBLIC_URL}/images/loading/w.png`}
                        alt='Phantom brave key art'
                    />{' '}
                    <img
                        className='loading-05'
                        src={`${process.env.PUBLIC_URL}/images/loading/l.png`}
                        alt='Phantom brave key art'
                    />{' '}
                    <img
                        className='loading-06'
                        src={`${process.env.PUBLIC_URL}/images/loading/o.png`}
                        alt='Phantom brave key art'
                    />{' '}
                    <img
                        className='loading-07'
                        src={`${process.env.PUBLIC_URL}/images/loading/a.png`}
                        alt='Phantom brave key art'
                    />{' '}
                    <img
                        className='loading-08'
                        src={`${process.env.PUBLIC_URL}/images/loading/d.png`}
                        alt='Phantom brave key art'
                    />{' '}
                    <img
                        className='loading-09'
                        src={`${process.env.PUBLIC_URL}/images/loading/i.png`}
                        alt='Phantom brave key art'
                    />{' '}
                    <img
                        className='loading-10'
                        src={`${process.env.PUBLIC_URL}/images/loading/n.png`}
                        alt='Phantom brave key art'
                    />{' '}
                    <img
                        className='loading-11'
                        src={`${process.env.PUBLIC_URL}/images/loading/g.png`}
                        alt='Phantom brave key art'
                    />{' '}
                    <img
                        className='loading-12'
                        src={`${process.env.PUBLIC_URL}/images/loading/deco.png`}
                        alt='Phantom brave key art'
                    />{' '}
                </div>
            </div>
        </div>
    )
}
